module.exports = __webpack_public_path__ + "img/blue-water.8dd5d742.svg";